import { unarchiveProjectDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const unarchiveProjectCallable = getCallable(unarchiveProjectDefinition);
